export default {
    name: 'StafetHeader',
    props: {
        steps: {
            type: Array,
            required: true,
            default: []
        },
        title: {
            type: String,
            required: true,
            default: ''
        },
        description: {
            type: String,
            required: true,
            default: ''
        }
    }
}
